import { z } from 'zod'

const envSchema = z.object({
  REACT_APP_API_URL: z.string().url().optional(),
  REACT_APP_API_URL_DEV: z.string().url().optional(),
  REACT_APP_API_URL_PROD_INTERNAL: z.string().url().optional(),
  REACT_APP_API_URL_TEST: z.string().optional(),

  REACT_APP_HUB_ROUTE: z.string().url(),

  REACT_APP_ENABLE_DELAY: z.coerce.boolean().default(false),

  REACT_APP_HOTEL_IMAGES_URL: z.string().url(),
  REACT_APP_HOTEL_UH_IMAGES_URL: z.string().url(),
  REACT_APP_AGENCY_SALE_POINT_IMAGES_URL: z.string().url(),

  REACT_APP_HOTEL_IMAGES_URL_PROD: z.string().optional(),
  REACT_APP_HOTEL_UH_IMAGES_URL_PROD: z.string().optional(),
  REACT_APP_AGENCY_SALE_POINT_IMAGES_URL_PROD: z.string().optional(),

  REACT_APP_GOOGLE_MAP_KEY: z.string(),

  REACT_APP_COGNITO_HOMOLOG_APP_CLIENT_ID: z.string(),
  REACT_APP_COGNITO_HOMOLOG_USER_POOL_ID: z.string(),

  REACT_APP_COGNITO_PRODUCTION_APP_CLIENT_ID: z.string().optional(),
  REACT_APP_COGNITO_PRODUCTION_APP_SECRET: z.string().optional(),
  REACT_APP_COGNITO_PRODUCTION_USER_POOL_ID: z.string().optional(),

  REACT_APP_CACHE_ENCRYPT_KEY: z.string(),

  REACT_APP_API_TEST_URL: z.string().url(),
  REACT_APP_AWS_REGION: z.string(),

  REACT_APP_ENV: z.enum([
    'development',
    'production',
    'homolog',
    'internal',
    'booking-dev',
  ]),

  REACT_APP_MICROSOFT_CLARITY_KEY: z.string().optional(),
  REACT_APP_ZENDESK_KEY: z.string().optional(),
  REACT_APP_SENTRY_SUBDOMAIN_CREDENTIAL: z.string().optional(),
  REACT_APP_SENTRY_TOKEN: z.string().optional(),
  REACT_APP_SENTRY_ROUTER_PATH: z.string().optional(),
  REACT_APP_GOOGLE_TAG_MANAGER_KEY: z.string().optional(),
  REACT_APP_GOOGLE_ANALYTICS_KEY: z.string().optional(),
  REACT_APP_MIXPANEL_TOKEN: z.string().optional(),
  REACT_APP_HOTJAR_KEY: z.string().optional(),
  REACT_APP_ENABLE_MSW: z.coerce.boolean().optional(),
})

const parsedEnv = envSchema.safeParse(import.meta.env)

if (parsedEnv.success === false) {
  console.error(
    '❌ Invalid environment variables.',
    parsedEnv.error.flatten().fieldErrors,
  )

  throw new Error('Invalid environment variables.')
}

export const env = parsedEnv.data
